import { render, staticRenderFns } from "./AccountSettingsMain.vue?vue&type=template&id=20a01821"
import script from "./AccountSettingsMain.vue?vue&type=script&lang=js"
export * from "./AccountSettingsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a01821')) {
      api.createRecord('20a01821', component.options)
    } else {
      api.reload('20a01821', component.options)
    }
    module.hot.accept("./AccountSettingsMain.vue?vue&type=template&id=20a01821", function () {
      api.rerender('20a01821', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/AccountSettings/AccountSettingsMain.vue"
export default component.exports